import { Reducer } from 'redux';

import { IGravesState } from 'types/graves.types';
import * as authConstants from 'redux/constants/auth.constants';
import * as constants from 'redux/constants/graves.constants';

export const defaultState: IGravesState = {
  blockId: null,
  cementeryId: null,
  count: 0,
  items: [],
  loading: false,
  selectedItem: null,
  states: {},
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'name',
    sortType: 'asc',
  },
};

const gravesReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.GRAVES_ON_DELETE_REQUESTED:
    case constants.GRAVES_ON_GET_ALL_REQUESTED:
    case constants.GRAVES_ON_SAVE_REQUESTED:
      return {
        ...state,
        blockId: action.blockId,
        cementeryId: action.cementeryId,
        loading: true,
      };
    case constants.GRAVES_ON_GET_ONE_REQUESTED:
      return {
        ...state,
        blockId: action.blockId,
        cementeryId: action.cementeryId,
        loading: !!action.id,
        selectedItem: null,
      };
    case constants.GRAVES_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.GRAVES_ON_GET_FORM_SUCCEEDED:
      return {
        ...state,
        loading: false,
        states: data.states,
      };
    case constants.GRAVES_ON_GET_ONE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: data.item,
      };
    case constants.GRAVES_ON_DELETE_SUCCEEDED:
    case constants.GRAVES_ON_SAVE_SUCCEEDED:
    case constants.GRAVES_ON_DELETE_FAILED:
    case constants.GRAVES_ON_GET_ALL_FAILED:
    case constants.GRAVES_ON_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.GRAVES_ON_GET_FORM_FAILED:
      return {
        ...state,
        loading: false,
        states: {},
      };
    case constants.GRAVES_ON_GET_ONE_FAILED:
      return {
        ...state,
        loading: false,
        selectedItem: null,
      };
    case authConstants.AUTH_ON_LOGOUT_SUCCEEDED:
    case authConstants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
      return defaultState;
    default:
      return state;
  }
};

export default gravesReducer;
